import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-meeting-data",
  templateUrl: "./meeting-data.component.html",
  styleUrls: ["./meeting-data.component.scss"],
})
export class MeetingDataComponent implements OnInit {
  meeting_details: any = "";
    originalNote: string = '';
  loader: boolean = false;
  apisub: Subscription
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private ls: LoaderServiceService,
    private activemodal: MatDialogRef<MeetingDataComponent>,
    private apiservice: ApiService
  ) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_VIRTUAL_MEETING_DATA){
        if(resdata.result){
          this.activemodal.close({msg:'success'})
        }
      }
    })

  }

  ngOnInit(): void {
    this.loader = true;
    console.log(this.parentdata);
    if (
      this.parentdata.data?.meeting_details &&
      typeof this.parentdata.data?.meeting_details == "string"
    ) {
      this.parentdata.data.meeting_details = JSON.parse(
        this.parentdata.data?.meeting_details
      );
    }
    if (this.parentdata.data?.meeting_details) {
      this.meeting_details =
        this.parentdata.data?.meeting_details[0]?.meeting_details &&
        this.parentdata.data?.meeting_details[0]?.meeting_details != "null"
          ? this.parentdata.data?.meeting_details[0]?.meeting_details
          : "";
      this.originalNote =
        this.parentdata.data?.meeting_details[0]?.meeting_details &&
        this.parentdata.data?.meeting_details[0]?.meeting_details != "null"
          ? this.parentdata.data?.meeting_details[0]?.meeting_details
          : "";
    }
    this.loader = false;
  }

  
  get isNoteChanged(): boolean {
  return this.meeting_details?.trim() !== this.originalNote?.trim();
}


  onConfirm() {
    let data = {
      hash_id:  this.parentdata.data?.meeting_details
      ? this.parentdata.data?.meeting_details[0]?.hash_id
      : null,
      meeting_details: this.meeting_details ? this.meeting_details : "",
      virtual_timing_hash:this.parentdata.data.hashId ,
    };

    Object.keys(data).forEach((key) => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });
    console.log(data);
    this.ls.showLoader = true;
    this.apiservice.updateVirtualMeetingDetails(data);
  }
}
